import { providerKey } from 'v2/pages/settings/integrations/utils/connection-rollout'
import type { RExternalOrgApp } from 'v2/types/api/settings'

const RECONNECT_REQUIRED = 'Reconnect required'

export interface ActionConnectionAvailability {
  disabled: boolean
  migrationLabel?: string
  tooltipContent?: string
}

/**
 * The rollout is intentionally one-way for execution: legacy rows remain visible for
 * migration and management, but only ACI owner IDs may be saved into new agent actions.
 */
export const getActionConnectionAvailability = (
  connection: Pick<RExternalOrgApp, 'integration_source'>,
  aciEnabled: boolean,
): ActionConnectionAvailability => {
  if (!aciEnabled || connection.integration_source === 'aci') {
    return { disabled: false }
  }

  return {
    disabled: true,
    migrationLabel: RECONNECT_REQUIRED,
    tooltipContent:
      'Reconnect this integration on the new integrations service to use it in agent actions.',
  }
}

/**
 * Provider match for binding a saved action to a connection.
 *
 * Under the rollout the two naming schemes coexist (legacy Nango key
 * "google-mail" vs the new service's "gmail"), so the match must go through
 * `providerKey`. Off the rollout there is only one scheme and the match stays
 * exact — aliasing there would bind actions the legacy console never bound.
 */
export const matchesActionProvider = (
  connectionProvider: string,
  savedProvider: string,
  aciEnabled = false,
) =>
  aciEnabled
    ? providerKey(connectionProvider) === providerKey(savedProvider)
    : connectionProvider === savedProvider
